import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  signal,
} from '@angular/core';
import {
  ActivatedRoute,
  Data,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-single-page-layout',
  imports: [RouterOutlet],
  templateUrl: './single-page-layout.component.html',
  styleUrl: './single-page-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SinglePageLayoutComponent {
  route = inject(ActivatedRoute);
  router = inject(Router);

  navEndEvents = toSignal(
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd))
  );
  firstChildRouteData = signal<Data | undefined>(undefined);

  constructor() {
    effect(async () => {
      this.navEndEvents();

      const data = await firstValueFrom(this.updateFirstChildRoute().data);
      this.firstChildRouteData.set(data);
    });
  }

  updateFirstChildRoute(): ActivatedRoute {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
